import styled from 'styled-components';
import Form from 'react-bootstrap/Form';
import theme from '../../config/theme';

export const Input = styled(Form.Control)`
  background: #FFFFFF;
  border: 2px solid #FFFFFF;
  box-sizing: border-box;
  backdrop-filter: blur(10px);
  border-radius: 8px;
  font-family: Nunito Sans, sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  height: 56px;
  ::placeholder{
    color: #C0C6D0
  }
  :disabled{
    background-color: #F3F6F8;
  }
  /*:active, :hover, :focus{
    //border: 1px solid ${theme.colors.primaryBlue};
  }*/
`